<template>
<div class="marketing">
  <div class="keywords">
    <div class="keywords__header">
      <h2>Google Ranking Keywords <span>2 / 5</span>
      <span class="updated">Last update <span>{{ lastUpdate }}</span></span></h2>
      <div>
        <el-button type="primary" icon="el-icon-plus">Keyword</el-button>
      </div>
    </div>
    <ul class="keywords__list">
      <li class="keywords__list--item" v-bind:key="keyword.index" v-for="keyword in keywords">
        <keyword :keyword="keyword"></keyword>
      </li>
    </ul>
  </div>
  <div class="google-settings">
    <div class="google-settings__header">
      <h2>Google Ranking Settings</h2>
    </div>
    <div class="google-settings__form">
      <div class="google-settings__form--col-1">
        <p>Check Google Ranking automatically:</p>
        <el-radio v-model="updateFrequency" label="day" disabled>Daily (upgrade)</el-radio>
        <el-radio v-model="updateFrequency" label="week">Weekly (your tariff)</el-radio>
        <el-radio v-model="updateFrequency" label="month">Monthly</el-radio>
        <el-radio v-model="updateFrequency" label="none">Don't check</el-radio>
      </div>
      <div class="google-settings__form--col-2">
        <el-checkbox v-model="emailReports">
          Send marketing report by email (recommended)
        </el-checkbox>
        <transition name="fade">
          <el-input
            v-show="emailReports"
            placeholder="Receiver"
            v-model="receiverAddress"
            clearable
          ></el-input>
        </transition>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import Keyword from './Keyword';

export default {
  data: () => ({
    updateFrequency: 'week',
    emailReports: false,
    receiverAddress: '',
    lastUpdate: '26.09.2017 04:23',
    keywords: [
      {
        index: 0,
        content: 'Michael Kwapis google',
        position: 245.244,
        progress: true,
      },
      {
        index: 1,
        content: 'Michael Kwapis internet',
        position: 127.292,
        progress: false,
      },
    ],
  }),
  components: {
    keyword: Keyword,
  },
};
</script>
<style lang="scss">
.marketing {
  position: absolute;
  top: 70px;
  right: 0;
  padding: 0 50px;
  width: calc(100% - 100px);

  .keywords {
    &__header {
      width: 100%;
      margin: 10px 0;
      border-bottom: 1px solid #aaaaaa;
      display: flex;
      justify-content: space-between;
      align-items: center;

      h2 {
        text-align: left;
        font-size: 24px;

        span {
          font-size: 16px;
          font-weight: 300;
        }

        .updated {
          font-size: 12px;
          padding-left: 20px;

          span {
            font-size: 12px;
            font-weight: 500;
          }
        }
      }
    }

    .keywords__list {
      list-style: none;
      padding: 0;

      &--item {
        position: relative;
        display: flex;
      }
    }

    .keywords__updated {
      margin-top: 20px;
      font-size: 12px;
      text-align: left;

      span {
        font-weight: 500;
      }
    }
  }

  .google-settings {
    &__header {
      width: 100%;
      margin: 20px 0 10px 0;
      border-bottom: 1px solid #aaaaaa;
      display: flex;
      justify-content: space-between;
      align-items: center;

      h2 {
        text-align: left;
        font-size: 24px;

        span {
          font-size: 16px;
          font-weight: 300;
        }
      }
    }

    &__form {
      display: flex;
      justify-content: stretch;
      align-items: flex-start;

      div {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }

      p {
        font-size: 16px;
        font-weight: 500;
        margin-bottom: 5px;
      }

      label {
        font-size: 14px;
      }

      .el-radio {
        margin: 5px 0;
      }

      .el-checkbox {
        margin-top: 16px;

        &__label {
          font-size: 16px;
          font-weight: 500;
        }
      }

      .el-input {
        margin-top: 15px;
        margin-left: 20px;
        max-width: 350px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Marketing.vue